<!-- upload-multiple-box.component.html -->

<div class="upload-container">
  <ion-button 
    expand="block" 
    fill="outline" 
    (click)="onSelectImages()"
    [disabled]="isUploading">
    
    <ion-spinner *ngIf="isUploading" slot="start" name="crescent"></ion-spinner>
    <ion-icon *ngIf="!isUploading" name="images-outline" slot="start"></ion-icon>
    
    <span *ngIf="!isUploading">{{ 'Choose Photos' }}</span>
    <span *ngIf="isUploading">Uploading...</span>
  </ion-button>

  <div *ngIf="selectedCount > 0 && !isUploading" class="selected-info">
    ✓ {{ selectedCount }} photo(s) uploaded
  </div>
</div>